'use client';

import { cn } from 'styles';
import { Modal, ModalProps } from '../Overlays';

import { CommandMenuProvider } from './Provider';

export function CommandMenuModal({ children, className, ...props }: ModalProps) {
  return (
    <Modal
      {...props}
      showCloseButton={false}
      className={cn('overflow-hidden p-0 shadow-lg phone:p-0', className)}
    >
      <CommandMenuProvider
        loop
        className="[&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:text-muted-foreground [&_[cmdk-group]:not([hidden])_~[cmdk-group]]:pt-0 [&_[cmdk-group]]:px-2 [&_[cmdk-input-wrapper]_svg]:h-5 [&_[cmdk-input-wrapper]_svg]:w-5 [&_[cmdk-input]]:h-12 [&_[cmdk-item]]:px-2 [&_[cmdk-item]]:py-3 [&_[cmdk-item]_svg]:h-5 [&_[cmdk-item]_svg]:w-5"
      >
        {children}
      </CommandMenuProvider>
    </Modal>
  );
}
